import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../reducers';
import { Logout } from '../auth';

@Injectable()
export class RedirectInterceptor implements HttpInterceptor {
  constructor(private router: Router, private store: Store<AppState>) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(
        (event) => {},
        (err) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401 && !/^\/auth\//.test(this.router.url)) {
              this.store.dispatch(new Logout({ redirect: false }));

              this.router.navigate(['/', 'auth', 'login'], {
                queryParams: { returnUrl: /^\/auth\/login/.test(this.router.url) ? '/' : this.router.url },
                queryParamsHandling: 'merge',
              });
            }
          }
        },
      ),
    );
  }
}
